module.exports = __webpack_public_path__ + "static/media/hdi-star.42e7b81e.svg";